const strategicCompass = {
  back: '← Terug naar teamomgeving',

  hero: {
    eyebrow: 'TOF Persona · Het Strategisch Kompas',
    titleLead: 'Wat de wereld vraagt, vertaald naar ',
    titleAccent: 'wie je team is',
    titleTail: '.',
    sub: "Voor MT en bestuur. Externe trends gekoppeld aan jouw team-persona's — een kompas voor de komende drie tot vijf jaar.",
    cta: 'Ontdek de aanpak',
    meta: '3–5 JAAR · TRAJECT VAN 4 MAANDEN',
  },

  why: {
    eyebrow: 'Waarom het Kompas',
    titleLead: 'Strategie zonder mensbeeld is een ',
    titleAccent: 'kompas zonder noord',
    titleTail: '.',
    lead: 'Veel strategie-trajecten kijken naar de buitenwereld — trends, markt, technologie. Andere kijken naar binnen — cultuur, leiderschap, teams. Het Strategisch Kompas doet beide. Trends raken organisaties altijd anders, afhankelijk van wie er werkt.',
    // De betaalde modules naast elkaar. Module 1 (de gratis app) staat hier
    // bewust niet in: die is de ingang, geen alternatief voor dit traject.
    compareHeads: ['TOF Persona Team', 'Organisatielandschap', 'Strategisch Kompas'],
    compareRows: [
      {
        label: 'Blik',
        cells: ['Naar binnen — het team', 'Naar binnen — de organisatie', 'Van buiten naar binnen'],
      },
      {
        label: 'Tijdshorizon',
        cells: ['Komende kwartalen', 'Dit jaar', '3–5 jaar'],
      },
      {
        label: 'Output',
        cells: ['Teamdashboard', 'Organisatielandschap', 'Strategisch richtingsdocument'],
      },
      {
        label: 'Doelgroep',
        cells: ['Teamleiders, HR', 'Directie, HR', 'MT en bestuur'],
      },
    ],
  },

  trendsSection: {
    eyebrow: 'De 8 trends die we volgen',
    titleLead: 'De wereld waarin ',
    titleAccent: 'jouw team',
    titleTail: ' straks werkt.',
    lead: 'Gecureerd uit Colliers Insights, WorkWire Trendrapport 2025–2026, Social Based Working en het AI Index Report 2026. Elk jaar herzien, zodat het kompas mee­beweegt.',
  },

  trends: [
    {
      num: '01',
      title: 'Experience based working',
      body: 'Van "wat je doet" naar "hoe je het ervaart". De werkplek wordt beoordeeld op gevoel, beleving en kwaliteit van de dag — niet op stoel en bureau.',
    },
    {
      num: '02',
      title: 'Van aanwezigheid naar waarde',
      body: 'Niet langer "twee dagen kantoor", maar: waarom kom je samen, wat levert dat op, en wat moet de omgeving daarvoor doen?',
    },
    {
      num: '03',
      title: 'Piekregie — de kamelenweek temmen',
      body: '75% wil op dinsdag of donderdag op kantoor. Sturen op samenkomst-momenten wordt cruciaal — niet op aantal dagen, maar op kwaliteit van die dagen.',
    },
    {
      num: '04',
      title: 'DEIB als ontwerp, niet als beleid',
      body: 'Inclusie verschuift van ambitie naar ontwerpvraagstuk: toegankelijkheid, prikkelarme zones, sociale veiligheid — zichtbaar in keuzes, niet in policy.',
    },
    {
      num: '05',
      title: 'Social based working',
      body: 'De werkplek als sociaal weefsel. Verbinding ontstaat niet vanzelf bij meer aanwezigheid — wel bij betekenisvolle momenten en sociale architectuur.',
    },
    {
      num: '06',
      title: 'Servicerevolutie',
      body: 'Het kantoor als hospitality-omgeving. Services en beleving — niet vierkante meters — bepalen of de plek aantrekkelijk is voor medewerkers.',
    },
    {
      num: '07',
      title: 'Van megacampus naar maatwerk',
      body: 'Kleinere, gerichte locaties dichter bij waar mensen wonen. Het centrale hoofdkantoor maakt plaats voor een netwerk van persoonlijkere plekken.',
    },
    {
      num: '08',
      title: 'AI in de werkplek',
      body: 'AI als stuurinstrument: continu meten van beleving, frictie en effectiviteit. Niet om medewerkers te controleren, maar om hun omgeving fijner te maken.',
    },
  ],

  methodSection: {
    eyebrow: 'De aanpak',
    titleLead: 'In 5 stappen naar ',
    titleAccent: 'jouw kompas',
    titleTail: '.',
    lead: 'Het Strategisch Kompas wordt gebouwd over vier maanden, in nauwe samenwerking met MT of bestuur. Geen losse adviesnota — een levend document dat ingebed wordt in jullie ritme.',
  },

  steps: [
    {
      num: '01',
      name: 'Intake',
      meta: '60 min · MT / bestuur',
      body: 'Wat is jullie organisatie-ambitie de komende 3–5 jaar? Welke beweging willen jullie maken? Wat zit er al, wat ontbreekt?',
    },
    {
      num: '02',
      name: 'Trend-spiegeling',
      meta: 'Voorbereiding · 2–3 weken',
      body: 'Welke van de 8 trends raken jullie organisatie het hardst? Welke versterken jullie ambitie, welke kruisen het? Hier komt de buitenwereld scherp binnen.',
    },
    {
      num: '03',
      name: 'Persona-overlay',
      meta: 'Uit de teambeelden en het Organisatielandschap',
      body: "Hoe verhouden jullie persona's zich tot die trends? Een Maker-zwaar team in een DEIB-gedreven organisatie vraagt iets héél anders dan een Verbinder-zwaar team.",
    },
    {
      num: '04',
      name: 'Ontwerpgesprek',
      meta: 'Halve dag · MT / bestuur',
      body: 'Trend-radar + persona-overlay komen samen op tafel. We maken keuzes voor leiderschap, werkomgeving, cultuur en technologie — onderbouwd en uitlegbaar.',
    },
    {
      num: '05',
      name: 'Het Kompas',
      meta: 'Levend document · jaarlijks bijgewerkt',
      body: 'Een ~20-pagina premium PDF plus een éénpager-overzicht voor MT-meetings. Geen plan in een la — een kompas dat jaarlijks meebeweegt.',
    },
  ],

  deliverableSection: {
    eyebrow: 'Wat je in handen krijgt',
    titleLead: 'Een document dat MT-meetings ',
    titleAccent: 'opent',
    titleTail: ', niet sluit.',
  },

  chapters: [
    'Context',
    'Wereldbeeld — trend-radar',
    'Teambeeld — persona-mix',
    'Snijpunt — waar trends + team raken',
    'Keuzes — 5–7 strategische richtingen',
    'Kompas — éénpager voor MT',
    'Jaarritme — wanneer kijken we terug?',
  ],

  deliverables: [
    { strong: 'Trend-radar', text: '8 trends, gewogen op relevantie voor jullie organisatie' },
    { strong: 'Persona-overlay', text: 'hoe jullie team-mix verhoudt zich tot die trends' },
    { strong: 'Strategische keuzes', text: 'voor leiderschap, werkomgeving, cultuur, technologie' },
    { strong: 'Kompas-éénpager', text: 'printbaar overzicht, klaar voor MT-meeting' },
    { strong: 'Jaarritme', text: 'vaste momenten om het kompas te herijken' },
  ],

  stackSection: {
    eyebrow: 'Waar het Kompas in past',
    titleLead: 'Vier modules, één ',
    titleAccent: 'verhaal',
    titleTail: '.',
    lead: 'Het Kompas staat op de schouders van wat ervoor komt. Pas als je weet wie er werkt, hoe teams samenwerken en hoe de organisatie eruitziet, kan je betekenisvol kijken naar waar je heen wilt.',
  },

  stack: [
    {
      num: '01 · De app',
      title: 'Wie ben jij?',
      body: 'De app op je telefoon. Je eigen profiel, je werkplekbehoefte, je gespreksvoorbereiding.',
    },
    {
      num: '02 · TOF Persona Team',
      title: 'Hoe werken jullie samen?',
      body: 'Teamdashboard. Persona-mix, spanningen, werkplek­behoefte en quick wins.',
    },
    {
      num: '03 · Organisatielandschap',
      title: 'Wat zie je over teams heen?',
      body: 'Alle teams naast elkaar, met duiding voor directie en HR.',
    },
    {
      num: '04 · Strategisch Kompas',
      title: 'Waar gaan we naartoe?',
      body: "Buiten naar binnen — trends + persona's vertaald naar strategie.",
    },
  ],

  cta: {
    titleLead: 'Klaar voor een ',
    titleAccent: 'scherper kompas',
    titleTail: '?',
    sub: 'Plan een vrijblijvend gesprek van 30 minuten. We kijken samen of dit traject past bij waar jullie organisatie staat.',
    primary: 'Plan een gesprek →',
    secondary: 'Terug naar modules',
  },
};

export default strategicCompass;
